import React from 'react';
import PropTypes from 'prop-types';
import Nav from './nav';

class Navigation extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return <Nav content={content.nav} />;
    }
}

export default Navigation;
